// removed by extract-text-webpack-plugin
module.exports = {"nav":"_30ARFBgXWxByBhxYScwnK","nav-prev":"_3qC31SOMYonNtEjGdSZpb6","nav-next":"_363tGZQ9vFxZGG7S7XC-vt","block":"_3geqT3VAFZJngNe-in0eJ6","slides":"_2WsSs5VrRp_pIE2IDFvkTC","slides-wrapper":"_2byr_1w6zUgHPuCZUtMjMB","nav-indicators":"u9UPJ9aGKccBq1ZlqKAFa","active":"_2mVFlB6E1uG9GXDZgQRsTb","direction-forward":"_3NVR9ce8sg9FZqcKUXOr54"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HMSBlock/HMSBlock.module.scss
// module id = 773
// module chunks = 0